import { IChallengeFormValues } from '@/components/challenge/CompanyChallengeManagement/types';

export const MAX_TITLE_LENGTH = 100;
export const MAX_DESCRIPTION_LENGTH = 500;
export const MAX_LABELS = 31;
export const EMPTY_LABEL = { index: 0, label: '' };
export const EMPTY_LABEL_ERROR = 'Fill in or remove empty labels before saving';
export const EMPTY_ONLY_LABEL_ERROR = 'At least one label required';
export const EMPTY_TITLE_ERROR = 'Title is required';

export const BLANK_VALUES: IChallengeFormValues = {
  title: '',
  description: '',
  labels: [EMPTY_LABEL],
};
